import React, { FC } from 'react';
import FormContainer from '../../Shared/FormContainer/FormContainer';
import LoadingSpinner from '../../Shared/LoadingSpinner/LoadingSpinner';
import { CenteredInfoContainer } from '../styled';
import { FORM_INFO_COMPONENT_TYPES } from '../types';
import { FormBody, FormInfoWrapper, ProssecingPayment } from './styled';

interface FormInfoFormsFilledProps {
  type: keyof typeof FORM_INFO_COMPONENT_TYPES;
  title: string;
  body: string;
  loading?: boolean;
  children?: React.ReactNode;
  aboveTitleElement?: React.ReactNode;
  error?: boolean;
}
const FormInfoFormsFilled: FC<FormInfoFormsFilledProps> = ({ type, title, body, loading, children, aboveTitleElement, error }) => {
  const { title: defaultTitle, body: defaultBody } = FORM_INFO_COMPONENT_TYPES[type];
  return (
    <FormInfoWrapper>
      <div>
        {loading && (
          <ProssecingPayment>
            <LoadingSpinner />
            <span>Forms are being processed</span>
          </ProssecingPayment>
        )}
        {!loading && !error && (
          <FormContainer title={title || defaultTitle} noNextButton noPreviousButton aboveTitleElement={aboveTitleElement} centerTitle>
            <CenteredInfoContainer>
              <FormBody>{body || defaultBody}</FormBody>
              {children}
            </CenteredInfoContainer>
          </FormContainer>
        )}

        {error && (
          <ProssecingPayment>
            <span>Something went wrong. Please contact support at support@collar.pet</span>
          </ProssecingPayment>
        )}
      </div>
    </FormInfoWrapper>
  );
};

export default FormInfoFormsFilled;
